import React from "react";

export default function ReportPrintTable({ columns, data }) {
  return (
    <table
      className="table table-bordered"
      style={{ fontSize: "12px", width: "100%" }}
    >
      <thead>
        <tr>
          {columns.map((col, i) => (
            <th key={i}>{col.name}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rIdx) => (
          <tr key={rIdx}>
            {columns.map((col, cIdx) => (
              <td key={cIdx}>
                {/* Support both selector function or key string */}
                {typeof col.selector === "function"
                  ? col.selector(row)
                  : row[col.selector]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
